"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReceiptType = exports.setReceiptOptions = exports.setSelectedPlan = exports.setPaymentDetails = void 0;
const redux_actions_1 = require("redux-actions");
exports.setPaymentDetails = (0, redux_actions_1.createAction)('SET_SALE_PAYMENT_DETAILS');
exports.setSelectedPlan = (0, redux_actions_1.createAction)('SET_SELECTED_PLAN');
exports.setReceiptOptions = (0, redux_actions_1.createAction)('SET_RECEIPT_OPTIONS');
exports.setReceiptType = (0, redux_actions_1.createAction)('SET_RECEIPT_TYPE');
